import React, { useEffect, useState } from "react";
import { billingImg } from "../../assets/image";
import {
  MasterCardIcon,
  SubscriptionIcon,
  HandCreditCard,
  HouseSearch,
} from "../../assets/svg/AllSvg";
import SubscriptionSalesTransactions from "./SubscriptionSalesTransactions";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getBillingSubscriptions } from "../../redux/billingSubscriptions/slice";
import RippleLoader from "../../commons/RippleLoader";
import moment from "moment";
import ViewInformation from "./components/ViewInformation";
import { Badge } from "../../components/micro";

const BillingAndSubscriptions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const company_id = sessionStorage.getItem("companyID");
  const [isId, setIsId] = useState("");

  // selector
  const { getBillingSubscriptionsData, loading } = useSelector((store) => ({
    getBillingSubscriptionsData:
      store?.billingSubscriptionsData?.getBillingSubscriptionsStatus?.data
        ?.data,
    loading: store?.billingSubscriptionsData?.loading,
  }));

  useEffect(() => {
    if (company_id) {
      dispatch(getBillingSubscriptions(company_id));
    }
  }, [dispatch, company_id]);

  return (
    <div className="space-y-5">
      {/* Page Heading */}
      <div className="flex items-center gap-4 border-b-2 pb-5">
        <div className="w-40">
          <img src={billingImg} alt="billingImg" className="w-full" />
        </div>
        <div>
          <h1 className="xl:text-3xl lg:text-2xl sm:text-xl text-base font-ebGaramond mb-2">
            My Billing and Subscriptions
          </h1>
          <p className="sm:text-sm text-xs">
            Manage your subscriptions and your transaction
          </p>
        </div>
      </div>
      {loading ? (
        <RippleLoader />
      ) : (
        <>
          <div className="grid xl:grid-cols-3 sm:grid-cols-2 gap-5">
            {/* My Subscription */}
            <div
              className="card bg-light_secondary_shades cursor-pointer flex flex-col justify-between"
              onClick={() =>
                navigate("/subscription", {
                  state: getBillingSubscriptionsData?.my_subscriptions,
                })
              }
            >
              <div className="flex gap-4">
                <div className="xl:max-w-14 lg:max-w-12 max-w-10 w-full">
                  <SubscriptionIcon className="w-full" />
                </div>
                <div className="space-y-2 w-full">
                  <p className="sm:text-xl text-base font-ebGaramond mb-2">
                    My Subscription
                  </p>
                  <div>
                    <p className="text-xs text-light_grey">Subscription Type</p>
                    <p className="sm:text-sm text-xs">
                      {getBillingSubscriptionsData?.my_subscriptions
                        ?.duration || "-"}{" "}
                      Year
                    </p>
                  </div>
                  <div>
                    <p className="text-xs text-light_grey">Expired on </p>
                    <p className="sm:text-sm text-xs">
                      {getBillingSubscriptionsData?.my_subscriptions?.end_date
                        ? moment(
                            getBillingSubscriptionsData?.my_subscriptions
                              ?.end_date
                          ).format("DD-MM-YYYY")
                        : ""}
                    </p>
                  </div>
                  <div className="flex items-center space-x-3">
                    <p className="sm:text-xl text-base font-ebGaramond">
                      Billing
                    </p>
                    <Badge
                      value={
                        getBillingSubscriptionsData?.my_subscriptions?.type ===
                        "recurring"
                          ? "Auto Renewal"
                          : "Cancel Auto Renewal"
                      }
                      className={`${
                        getBillingSubscriptionsData?.my_subscriptions?.type ===
                        "recurring"
                          ? "bg-green"
                          : "bg-warning_color"
                      } text-white text-xs capitalize !py-1`}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-end">
                <button className="text-theme border-b border-theme uppercase text-sm">
                  View more
                </button>
              </div>
            </div>
            {/* My Payment Method */}
            <div
              className="card bg-primary_shades_light cursor-pointer "
              onClick={() => navigate("/payment-method")}
            >
              <div className="flex gap-4">
                <div className="xl:max-w-14 lg:max-w-12 max-w-10 w-full">
                  <HandCreditCard className="w-full" />
                </div>

                <div className="space-y-2 w-full">
                  <p className="sm:text-xl text-base font-ebGaramond mb-2">
                    My Payment Method
                  </p>
                  <div>
                    <p className="text-xs text-light_grey">Payment method</p>
                    <p className="sm:text-sm text-xs">
                      {getBillingSubscriptionsData?.card?.number ? "Card" : "-"}
                    </p>
                  </div>
                  <div className="flex items-center space-x-2">
                    {getBillingSubscriptionsData?.card?.number && (
                      <div className="max-w-12 w-full">
                        <MasterCardIcon />
                      </div>
                    )}
                    <div>
                      <p className="text-xs text-light_grey">Expired on </p>
                      <p className="sm:text-sm text-xs">
                        {getBillingSubscriptionsData?.card?.number || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-end mt-2">
                <button
                  className={`${
                    getBillingSubscriptionsData?.card?.number
                      ? "text-theme border-b border-theme"
                      : "btn-theme w-full"
                  } uppercase text-sm`}
                >
                  {getBillingSubscriptionsData?.card?.number
                    ? "UPDATE"
                    : "Add payment method"}
                </button>
              </div>
            </div>
            {/* Billing information */}
            <div
              className="card bg-primary_shades_light cursor-pointer flex flex-col justify-between"
              onClick={() => navigate("/billing")}
            >
              <div className="flex gap-4">
                <div className="xl:max-w-14 lg:max-w-12 max-w-10 w-full">
                  <HouseSearch className="w-full" />
                </div>
                <div className="space-y-2 flex flex-col justify-between w-full">
                  <div className="space-y-2">
                    <p className="sm:text-xl text-base font-ebGaramond mb-2">
                      Billing information
                    </p>
                    <div>
                      <p className="text-xs text-light_grey">
                        {`${
                          getBillingSubscriptionsData?.billing_information
                            ?.address ?? "-"
                        } ${
                          getBillingSubscriptionsData?.billing_information?.city
                            ? getBillingSubscriptionsData?.billing_information
                                ?.city + ","
                            : ""
                        } ${
                          getBillingSubscriptionsData?.billing_information
                            ?.state
                            ? getBillingSubscriptionsData?.billing_information
                                ?.state + ","
                            : ""
                        } ${
                          getBillingSubscriptionsData?.billing_information
                            ?.zipcode ?? ""
                        }`}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-end mt-2">
                <button
                  className={`${
                    getBillingSubscriptionsData?.billing_information?.address
                      ? "text-theme border-b border-theme"
                      : "btn-outline w-full"
                  } uppercase text-sm`}
                >
                  {getBillingSubscriptionsData?.billing_information?.address
                    ? "UPDATE"
                    : "Add Biling information"}
                </button>
              </div>
            </div>
          </div>
          {/* Subscription & Sales Transactions */}
          <SubscriptionSalesTransactions
            getBillingSubscriptionsData={getBillingSubscriptionsData}
            setIsId={setIsId}
          />
        </>
      )}
      {isId && <ViewInformation onClose={() => setIsId("")} isId={isId} />}
    </div>
  );
};

export default BillingAndSubscriptions;
